<template>
  <div class="upload-files">
    <div style="width: 100%" v-if="model && /^http[s]*:\/\//.test(model)" class="upload-list">
      <span style="padding-right: 6px">{{ decodeURIComponent(model.split('/').at(-1)).replace(/^[\d]+_/, '') }}</span>
      <a :href="model" target="_blank">
        <el-icon><Download /></el-icon>
      </a>
      <el-icon class="del" v-if="!disabled" @click="handleUploadRemove()">
        <DeleteFilled />
      </el-icon>
    </div>

    <el-upload v-loading="status == 'uploading'" :show-file-list="false" :multiple="false" :auto-upload="true" :before-upload="handleUploadBefore" :http-request="handleUploadRequest" :accept="accept">
      <el-button type="primary" :icon="Plus">{{ ['上传文件', 'Upload'][$language] }}</el-button>
    </el-upload>
  </div>
</template>

<script setup>
  import OSS from 'ali-oss'
  import { getOSSSTS } from '@/api/config'
  import { Delete, Download, Plus, ZoomIn, Close, CloseBold, Loading, DeleteFilled } from '@element-plus/icons-vue'
  import { translate } from '@/i18n'
  import { ref, inject, watch } from 'vue'
  import { ElMessage, ElMessageBox } from 'element-plus'
  const props = defineProps({
    modelValue: {
      type: String,
      default: '',
    },
    maxSize: {
      type: Number,
      default: 50,
    },
    filetype: {
      type: Array,
      default: ['jpg', 'jpeg','png', 'pdf', 'docx', 'doc'],
    },
    accept: {
      type: String,
      default: 'image/jpeg,image/jpg,image/png,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document,application/pdf',
    },
  })
  const emit = defineEmits(['update:modelValue'])
  const $language = inject('$language')
  const model = ref('')

  const visible = ref(false)
  const status = ref('')
  const progress = ref(0)

  watch(
    () => props.modelValue,
    () => {
      if (props.modelValue) {
        model.value = props.modelValue
        status.value = '' //上传中
        progress.value = 0
      } else {
        model.value = ''
        status.value = '' //上传中
        progress.value = 0
      }
    },
    {
      immediate: true,
    }
  )

  const handleUploadRequest = async ({ file }) => {
    status.value = 'uploading' //上传中
    const { ret, data: ossConfig } = await getOSSSTS()
    if (ret !== 0) {
      status.value = 'error' //上传中
      ElMessage({ message: ['获取上传授权失败', 'Get token fail'][$language.value], type: 'error' })
      return
    }
    const client = new OSS({
      region: ossConfig.region,
      accessKeyId: ossConfig.accessKeyId,
      accessKeySecret: ossConfig.accessKeySecret,
      stsToken: ossConfig.securityToken,
      bucket: ossConfig.bucket,
    })
    try {
      let extFileName = file.name.substring(file.name.lastIndexOf('.') + 1)
      progress.value = 0
      const res = await client.multipartUpload(ossConfig.path + '_' + file.name, file, {
        progress: (p) => {
          console.log(p)
          progress.value = p * 100
        },
      })
      console.log(res)
      model.value = `https://${res.bucket}.${ossConfig.region}.aliyuncs.com/${res.name.replace(/^\//, '')}`
      console.log(model.value)
      console.log('update:modelValue', model.value)
      emit('update:modelValue', model.value)
      status.value = '' //上传中
    } catch (e) {
      console.log(e)
      status.value = 'error' //上传中
      ElMessage({ message: ['上传失败', 'Upload fail'][$language.value], type: 'error' })
    }
  }

  const handleUploadRemove = () => {
    ElMessageBox.confirm(['确认删除当前文件？', 'Delete the file. Continue?'][$language.value], '', {
      type: 'warning',
    }).then(() => {
      model.value = ''
      emit('update:modelValue', model.value)
    })
  }
  const handleUploadBefore = (file) => {
    let extFileName = file.name.substring(file.name.lastIndexOf('.') + 1)
    console.log(extFileName)
    let fileTypeCheckResult = props.filetype.some((ft) => {
      return extFileName.toLowerCase() === ft.toLowerCase()
    })
    if (!fileTypeCheckResult) {
      ElMessage({ message: ['文件格式不允许', 'File type is error'][$language.value], type: 'error' })
      return false
    }
    if (file.size / 1024 / 1024 > props.maxSize) {
      ElMessage({ message: ['文件大小超出限制', 'File size is error'][$language.value], type: 'error' })
      return false
    }
    return true
  }
</script>

<style lang="scss" scoped>
  .upload-list {
    width: 100%;
    position: relative;
    line-height: 30px;
    height: 30px;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    margin-bottom: 6px;
    .del {
      position: absolute;
      right: 0;
      color: var(--el-color-danger);
      cursor: pointer;
      margin-top: 8px;
    }
    a {
      color: var(--el-color-primary);

      display: flex;
      justify-content: flex-start;
    align-items: center;
      
    line-height: 30px;
    height: 30px;
    margin-left: 12px;
    }
  }
</style>
